import React from "react";
import TimePicker from "components/TimePicker";
import OutlinedDiv from "components/OutlinedDiv";

export default ({ formik, editable }) => {
  return (
    <>
      <OutlinedDiv label="Working Hours">
        <div className="row">
          <div className="col-md-6 col-sm-6 col-lg-6">
            <TimePicker
              label="Start"
              value={formik.values.working_hours_start}
              onChange={(value) => {
                formik.setFieldValue("working_hours_start", value);
              }}
              disabled={!editable}
              className="user-profile-time-input"
            />
          </div>
          <div className="col-md-6 col-sm-6 col-lg-6">
            <TimePicker
              label="End"
              value={formik.values.working_hours_end}
              onChange={(value) => {
                formik.setFieldValue("working_hours_end", value);
              }}
              disabled={!editable}
              className="user-profile-time-input"
            />
          </div>
        </div>
      </OutlinedDiv>
      <OutlinedDiv label="Personal Availability Hours">
        <div className="row">
          <div className="col-md-6 col-sm-6 col-lg-6">
            <TimePicker
              label="Start"
              value={formik.values.personal_hours_start}
              onChange={(value) => {
                formik.setFieldValue("personal_hours_start", value);
              }}
              disabled={!editable}
              className="user-profile-time-input"
            />
          </div>
          <div className="col-md-6 col-sm-6 col-lg-6">
            <TimePicker
              label="End"
              value={formik.values.personal_hours_end}
              onChange={(value) => {
                formik.setFieldValue("personal_hours_end", value);
              }}
              disabled={!editable}
              className="user-profile-time-input"
            />
          </div>
        </div>
      </OutlinedDiv>
    </>
  );
};
